/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table[_ngcontent-%COMP%]{margin-top:14px;margin-bottom:14px}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(2){border-top:1px solid #adb5bd;border-bottom:1px solid #adb5bd}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:7px}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{padding-right:14px}p.main-info[_ngcontent-%COMP%]{text-align:center;margin-top:45px;margin-bottom:67.5px}p.main-info[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{font-size:200%}"];
export { styles as styles };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/contact/contact.component.scss.shim.ngstyle.js.pre-build-optimizer.js